import React from 'react'
import {Image} from 'cloudinary-react'
import SlideWrapper from './slideWrappers/SlideWrapper'
import StaticLetterBlock from './StaticLetterBlock'
import FallbackStaticQuestionSlide from './FallbackStaticQuestionSlide'
import {getTemplateDefinition} from '../../utils/slides/getTemplateDefinition'
import {isSurvey} from '../../utils/isSurvey'

class QuestionSlide extends React.Component{
 	
	constructor(){
		super()
		this.onMouseEnterChoice=this.onMouseEnterChoice.bind(this)
		this.onMouseEnterChoicesGroup=this.onMouseEnterChoicesGroup.bind(this)
		this.onMouseLeaveChoicesGroup=this.onMouseLeaveChoicesGroup.bind(this)
	}


	onMouseEnterChoice(choiceLetter){
		if(this.props.onMouseEnterChoice){
			this.props.onMouseEnterChoice(choiceLetter)
		}
	}

	onMouseEnterChoicesGroup(){
		if(this.props.onMouseEnterChoicesGroup){
			this.props.onMouseEnterChoicesGroup()
		}
	}
	onMouseLeaveChoicesGroup(){
		if(this.props.onMouseLeaveChoicesGroup){
			this.props.onMouseLeaveChoicesGroup()
		}
	}



	render(){
		const {isLiveView,showResponseCounts,expectedResponses,colorScheme,alwaysShowLetterblock,question,displayWidth,isReviewScreen, reportView,showCorrect,showGraph,processedResponses, isScanScreen, isAskScreen, totalResponses,choicesGroupHovered} = this.props
		let slideTemplate='standard'
		let template

		if(question){
			const isSurveyQuestion=isSurvey(question)
			slideTemplate=question.template || 'standard'
			template=getTemplateDefinition(slideTemplate,question.image,question.body)	

			if(question.xLayout){
				const bodyFontSize=question.xLayout.bodyFS
				const choiceFontSize=question.xLayout.choiceFS
				if(bodyFontSize && choiceFontSize ){
					let bodyCalcCSS= {fontSize: `${bodyFontSize}px`}
					const choicesCalcCSS = {fontSize: `${choiceFontSize}px`}
					const letterArray=['A','B','C','D']
				

					return(
						<SlideWrapper displayWidth={displayWidth} isStatic={true} template={template} reportView={reportView} key={question.image}>	
							<div className='slide-body' style={bodyCalcCSS} >
								{question.body}		
							</div>																		
					

							<div className='slide-imageContainer'> 
								{question.image &&
								<Image					
									cloudName={process.env.REACT_APP_CLOUDINARY_CLOUDNAME}
									publicId={question.image}                                                 
									role='presentation'
									responsive
									dpr='auto'							
			    				width= '900' 
			    				height='900'
			    				crop= 'limit'   
			    				fetchFormat='auto'
			    				quality='auto'
								/>
				
								}
							</div>

							<div style={choicesCalcCSS}>
								<div className={"slide-choices " + (choicesGroupHovered? 'slide-choices--delayHovered':' slide-choices--notDelayHovered')} onMouseEnter={this.onMouseEnterChoicesGroup} onMouseLeave={this.onMouseLeaveChoicesGroup}>
									{question.choices.map(function (choice,key) {
										let graphPercentageWidth	
										let responseCount=0

										if(processedResponses){
											let graphScaling=totalResponses
											if(isLiveView){
												graphScaling=expectedResponses
											}
											graphPercentageWidth = processedResponses[`responsesAnswer${letterArray[key]}`].length / graphScaling * 100
											responseCount = processedResponses[`responsesAnswer${letterArray[key]}`].length	
										}
										let displayGraph=false
										let displaySyncGraph= false
										if(showGraph){
											displayGraph = true
											displaySyncGraph = true
										}
										else if(reportView){
											displayGraph = true									
										}

										
								const studentSyncHoverNotSelection = false

	    					return(
	    						<div onMouseEnter={()=>{this.onMouseEnterChoice(letterArray[key])}} className={`slide-choice choice--${key}` + (choice.correct ? ' is--correct' : ' isNot--correct') + (colorScheme ? ` is--${colorScheme} `: '') + (isSurveyQuestion ? ' is--survey' : ' isNot--survey') + (isReviewScreen ? ' is--review' : ' ') + (isAskScreen ? ' is--ask' : ' isNot--ask ') + (showCorrect ? ' is--showCorrect' : ' isNot--showCorrect') + (isScanScreen ? ' is--scan': ' isNot--scan') + (showResponseCounts ? ' is--showResponseCounts ': ' isNot--showResponseCounts ') + (displaySyncGraph ? ' is--displaySyncGraph ': ' isNot--displaySyncGraph ')} key={key}>
	    							<StaticLetterBlock 
	    								index={key}	    									    								
	    								isReviewScreen={isReviewScreen}
	    								reportView={reportView}
	    								showCorrect={showCorrect}
	    								isCorrect={choice.correct}
	    								alwaysShowLetterblock={alwaysShowLetterblock}
	    								isSurvey={isSurveyQuestion}
	    							/>	    						
		    						<div className="slide-choice-textContainer">					 				
							 				<div ref='test' className='slide-choice-text'>
							 					{choice.body}
							 				</div>
							 			</div>
							 			{displayGraph &&
							 				<div className='slide-choice-graph'>			 				
							 					<div style={{width: `${graphPercentageWidth}%` }} className='slide-choice-graph-bar' />
							 				</div>
						 				}
						 				{displayGraph && showResponseCounts &&
							 				<div className={'slide-choice-responseCount ' + (responseCount === 0 ? 'slide-choice-responseCount--isZero' : '')}>
							 					{responseCount}
							 				</div>
							 			}
					 				
											</div>)}.bind(this))}
								</div>
							</div>
						</SlideWrapper>	)}else 
					return (
						<FallbackStaticQuestionSlide
							{...this.props}
							template={template}
						/>)
			}
			else{ return(
				 <FallbackStaticQuestionSlide
					{...this.props}
					template={template}
				/>)}
		}else return null}
}


QuestionSlide.defaultProps = {
	displayWidth: 1280,
	showCorrect:false

}




export default QuestionSlide

